<template>
  <Modal
    v-model="_value"
    width="500"
    title="通立设置司机卡"
    @on-visible-change="visibleChange"
    ok-text="关闭"
    cancel-text="">
    <Form ref="setDriverCardParamsRef" v-model="setDriverCardParams" :label-width="90">
      <FormItem prop="driverName" label="驾驶员名">
        <Input v-model="setDriverCardParams.driverName" placeholder="请输入驾驶员名">
        </Input>
      </FormItem>
<!--      <FormItem prop="driverCardNum" label="从业资格证号">-->
<!--        <Input v-model="setDriverCardParams.driverCardNum" placeholder="请输入从业资格证号">-->
<!--        </Input>-->
<!--      </FormItem>-->
      <FormItem prop="driverLicenseNum" label="驾驶证号">
        <Input v-model="setDriverCardParams.driverLicenseNum" placeholder="请输入驾驶证号">
        </Input>
      </FormItem>
      <FormItem prop="organizationNames" label="发证机构名称">
        <Input v-model="setDriverCardParams.organizationNames" placeholder="请输入发证机构名称">
        </Input>
      </FormItem>
      <FormItem prop="sex" label="性别">
        <Select v-model="setDriverCardParams.sex" style="width: 220px;">
          <Option v-for="item in sexOptions" :value="item.label" :key="item.label">
            {{item.label}}
          </Option>
        </Select>
      </FormItem>
      <FormItem prop="indate" label="证件有效期">
        <DatePicker style="display: inline-block; width: 200px;" type="date" v-model="setDriverCardParams.indate"
                    placeholder="选择日期"></DatePicker>
      </FormItem>
      <Button type="primary" @click="onCleanDriverCardParams" style="margin-right: 5px;">清空</Button>
      <Button type="primary" @click="onSendDriverCardParams">发送</Button>
    </Form>
  </Modal>
</template>

<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'tlsetdrivercardmodal',
  components: {

  },
  props: {
    initValue: null,
    terminalNumValue: null,
    value: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      setDriverCardParams: {
        id: null,
        driverCardNum: null,
        driverName: null,
        driverLicenseNum: null,
        organizationNames: null,
        sex: '男',
        indate: null
      },
      sexOptions: [
        { label: '男', value: 1 },
        { label: '女', value: 2 }
      ]
    }
  },
  methods: {
    ...mapActions([
      'VehicleInfoServ_SearchByName'
    ]),
    visibleChange (val) {
      if (val) {
        this.setDriverCardParams.id = this._initValue
        this.setDriverCardParams.driverCardNum = null
        this.setDriverCardParams.driverName = null
        this.setDriverCardParams.driverLicenseNum = null
        this.setDriverCardParams.organizationNames = null
        this.setDriverCardParams.sex = '男'
        this.setDriverCardParams.indate = null
      }
    },
    onCleanDriverCardParams () {
      this.setDriverCardParams.driverCardNum = null
      this.setDriverCardParams.driverName = null
      this.setDriverCardParams.driverLicenseNum = null
      this.setDriverCardParams.organizationNames = null
      this.setDriverCardParams.sex = '男'
      this.setDriverCardParams.indate = null
    },
    onSendDriverCardParams () {
      if (this.setDriverCardParams.driverName == null) {
        this.$Message.error('驾驶员名不能为空')
        return
      }
      this.setDriverCardParams.driverCardNum = this.setDriverCardParams.driverLicenseNum
      if (this.setDriverCardParams.driverCardNum == null) {
        this.$Message.error('从业资格证号不能为空')
        return
      }
      if (this.setDriverCardParams.driverLicenseNum == null) {
        this.$Message.error('驾驶证号不能为空')
        return
      }
      if (this.setDriverCardParams.organizationNames == null) {
        this.$Message.error('发证机构名称不能为空')
        return
      }
      if (this.setDriverCardParams.sex == null) {
        this.$Message.error('性别不能为空')
        return
      }
      if (this.setDriverCardParams.indate == null) {
        this.$Message.error('请输入有效期')
      } else {
        this.setDriverCardParams.indate = this.setDriverCardParams.indate.Format('yyyy-MM-dd').substring(2)
      }
      // <EXTIC2,驾驶证号码,驾驶证有效期,从业资格证号码,从业资格证有效期,驾驶员姓名,驾驶员代码,发证机构,性别,星级>
      console.log('<EXTIC2,驾驶证号码,驾驶证有效期,从业资格证号码,从业资格证有效期,驾驶员姓名,驾驶员代码,发证机构,性别,星级>')
      store.dispatch('NetCommandServ_SendCommand', {
        params: { id: this._initValue, content: '<EXTIC2,' + this.setDriverCardParams.driverLicenseNum + ',' + this.setDriverCardParams.indate + ',' + this.setDriverCardParams.driverCardNum + ',' + this.setDriverCardParams.indate + ',' + this.setDriverCardParams.driverName + ',' + this.setDriverCardParams.driverCardNum.substring(11) + ',' + this.setDriverCardParams.organizationNames + ',' + this.setDriverCardParams.sex + ',' + 5 + '>', urgent: true }
      }).then(() => {
        this.$Message.success('发送成功')
        let queryParams = []
        queryParams.push(genQueryParam('terminalNum', 'EQ', this._terminalNumValue))
        store.dispatch('DriverCardDataResultServ_GetPage', {
          params: null,
          urlparams: {
            q: queryParams
          }
        }).then(res => {
          // console.log(res)
          if (store.getters.get_DriverCardDataResult_GetPageResult) {
            // console.log(store.getters.get_DriverCardDataResult_GetPageResult)
            let driverCardDataResults = store.getters.get_DriverCardDataResult_GetPageResult.content
            for (let i = 0; i < driverCardDataResults.length; i++) {
              if (driverCardDataResults[i].processState != 3) {
                driverCardDataResults[i].processRemark = '写卡'
                driverCardDataResults[i].processState = 3
                store.dispatch('DriverCardDataResultServ_AddProcessRemark', {
                  params: driverCardDataResults[i]
                }).then(() => {
                  // this.refreshPage(this.pageFilter)
                }).catch(err => {
                  this.$Message.error(err)
                })
              }
            }
          }
        }).catch(err => {
          console.log(err)
        })
      }).catch(err => {
        this.$Message.error(err)
      })
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    },
    _terminalNumValue: {
      get () {
        return this.terminalNumValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
